export default {
  participant: 'Participant',
  participants: 'Participants',
  verbose_participant: 'un participant',
};
